import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { CustomCard } from "../../Utils/UI/Text";
import "./BarChart.css";
import { Typography } from "antd";
import Loader from "./../../Loader/Loader";
const { Text } = Typography;

function BarChart({ barData, isLoading }) {
  const [years, setYears] = useState();
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({});
  const [colors] = useState(["#0319a3"]);

  useEffect(() => {
    if (!barData?.emission_per_year) return;

    let yearsData = [];
    let totalData = [];
    const emissionsData = barData.emission_per_year;

    for (let obj in emissionsData) {
      const emission = emissionsData[obj];
      yearsData.push(emission.year);
      totalData.push(emission.emission);
    }

    setYears(yearsData);
    setSeries([
      {
        name: "Emission",
        data: totalData,
      },
    ]);

    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [barData?.emission_per_year]);

  useEffect(() => {
    if (years !== undefined) {
      setOptions(_options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [years]);

  const _options = {
    colors: colors,
    tooltip: { enabled: false },
    chart: {
      type: "bar",
      padding: {
        top: 10,
        bottom: 0,
        left: 20,
        right: 20,
      },
      toolbar: {
        tools: {
          download: false,
          selection: true,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
        },
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        horizontal: false,
        columnWidth: "50%",
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return Number(val).toLocaleString();
      },
      offsetY: -20,
      style: {
        fontSize: "12px",
        colors: ["#0319a3"],
      },
    },
    xaxis: {
      categories: years,
      labels: {
        style: {
          fontSize: "12px",
        },
        offsetX: 5,
      },
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: true,
      },
    },
  };

  const hasData =
  Array.isArray(barData?.emission_per_year) &&
  barData.emission_per_year.length > 0;

  return (
    <CustomCard>
      <span className="title-bar-chart">Emission per year</span>
      {isLoading ? (
        <div className="loader-bar">
          <Loader />
        </div>
      ) : !hasData ? (
        <div className="no-results-container">
          <Text className="no-data-message">No results found.</Text>
        </div>
      ) : (
        <div style={{ padding: "0 10px" }}>
          <Chart
            options={options}
            series={series}
            type="bar"
            height={300}
            width="100%"
          />
        </div>
      )}
    </CustomCard>
  );
}

export default BarChart;
